/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_2_DInputs */

const en_cp_ch_2_d = /** @type {(inputs: Cp_Ch_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readiness score, verified tasks, a running deployment.`)
};

const id_cp_ch_2_d = /** @type {(inputs: Cp_Ch_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor kesiapan, task terverifikasi, deploy yang berjalan.`)
};

/**
* | output |
* | --- |
* | "Readiness score, verified tasks, a running deployment." |
*
* @param {Cp_Ch_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_2_d = /** @type {((inputs?: Cp_Ch_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_2_d(inputs)
	return en_cp_ch_2_d(inputs)
});